module.exports = __webpack_public_path__ + "img/footer-contact-icon-row-dark-hyundai.360e7129.png";